import type { Coin } from '@ninjablaze/sdk-ts'

export type Lootbox = LootboxV2 | LootboxLimitedDeprecated

export type Reward = RewardV2 | RewardDeprecated

export type RewardV2 = { weight: number; chance: number; multiplier: number; image: Record<string, string> }

export type LootboxV2 = {
  id: string
  slug: string
  type: LootboxType.UNLIMITED
  redirects: Array<string>
  availableMultipliers: Array<number>
  state: LootboxState
  price: Record<string, string>

  image: {
    src: string
  }
  rewards: Record<string, RewardV2>
  metadata: {
    rtp: number
    shadowColor: string
    tags: Array<string>
    title: string
    priority: number
    risk: RiskLevelEnum
    banner: boolean
    collections: boolean
    comment: string
    maxMultiplier: number
  }
}

export type LootboxLimitedDeprecated = LootboxLimited & LootboxMetadata

export type LootboxLimited = {
  type: LootboxType.LIMITED
  market: boolean
  limited: {
    openDeadline: string
    quantity: number
    contracts: {
      sale: string
      market: string
    }
    sale: {
      price: {
        amount: string
        denom: string
      }
    }
  }
}

export enum RiskLevelEnum {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

export type LootboxMetadata = {
  id: string
  open: {
    price: {
      amount: string
      denom: string
    }
  }
  isRevealed: boolean
  banner: boolean
  collections: boolean
  contract: string
  state: LootboxState
  title: string
  slug: string
  image: { src: string; shadowColor: string }
  description: string
  tags: Array<string>
  comment: string
  maxMultiplier: number
  rewards: Record<string, RewardDeprecated>
}

export type RewardDeprecated = {
  rarity: number
  chance: number
  quantity: number
  title: string
  titleDenom?: string
  image: string
  unlimited?: boolean
  items: {
    tokens: Coin[]
    nfts: []
    wasm: []
  }
}

export enum LootboxType {
  LIMITED = 'limited',
  UNLIMITED = 'unlimited',
}

export enum LootboxState {
  SALE = 'sale',
  ACTIVE = 'active',
  BLOCKED = 'block',
}

export const getLootboxImagePrefix = (denom: string) => {
  return denom // todo: delete
}
